<svg width="118" height="50" viewBox="0 0 118 50" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="22.4597" cy="26.5969" r="21.9597" fill="#FFF7DE" fill-opacity="0.3" stroke="#33EB40"/>
<circle cx="95.5403" cy="26.5974" r="21.9597" fill="#FFF7DE" fill-opacity="0.3" stroke="#33EB40"/>
<circle cx="29.2567" cy="16.2537" r="16.2537" fill="#33EB40"/>
<circle cx="95.8358" cy="26.8924" r="16.2537" fill="#33EB40"/>
</svg>
